import React, { useState, useContext, createContext, useEffect } from 'react'
import "antd/dist/antd.css";
import { Form, Button, Input, Select, Modal, Row, Col, notification } from 'antd';
import konsole from '../network/konsole'
import Services from '../network/Services'
import Address from './Address'
import { GlobalData } from './Seminar/SeminarFile';
import { UserContext } from '../App';
export const GlobalVenue = createContext();
const { Option } = Select;


const AddEditVenue = ({ visible, onCancel, status, statusId, RecallgetvenueDataAPI, getAddressByAddressId }) => {




  const [form] = Form.useForm();

  const { setLoader } = useContext(UserContext)

  const [getVenueName, setGetVenueName] = useState("")

  const [getAddressId, setGetAddressId] = useState("")
  let subtenantId = sessionStorage.getItem('subtenantId')
  let loginUserId = sessionStorage.getItem('loggedUserId')
  konsole.log("MyVenue", getVenueName)


  status(getVenueName)
  // konsole.log("Statusstatus",status)

  const [loggedUserId, setLoggedUserId] = useState("")
  useEffect(() => {
    let loggedUserId = sessionStorage.getItem('loggedUserId')
    konsole.log('respaaa', loggedUserId)
    setLoggedUserId(loggedUserId)
  }, [])

  const openNotification = (placement, Status) => {

    if (Status == 500) {

      notification.error({
        message: `Error ${Status} `,
        description:
          'Server Issue! Please try after sometime.',
        placement,
      });
    } else if(Status == 200){
      notification.success({
        message: `Venue added successfully`,

        placement,
      });
    }

  };


  let AddressId;

  const EndedData = (postData) => {
    setLoader(true)
    setGetVenueName(postData.venueName)
    konsole.log("data", postData);
    let mainAddress = postData.address;
    let mainCity = postData.city;
    let mainState = postData.state;
    let mainCountry = postData.country;
    let mainZipCode = postData.zipcode
    let mainVenue = postData.venueName

    sendData(mainAddress, mainCity, mainState, mainCountry, mainZipCode, mainVenue)

  }

  const sendData = (mainAddress, mainCity, mainState, mainCountry, mainZipCode, mainVenue) => {
    const AddressData = Services.addressData(null, null, mainAddress, null, null, mainZipCode, 'no', mainCity, mainState, mainCountry, 1, loggedUserId)
    AddressData.then((res) => {
      konsole.log(res.data)
      konsole.log("AddressId:", res.status);
      SendVenue(res.data.data.addressId, mainVenue)
      openNotification('topRight', res.status)
    })
      .catch((err) => {
        konsole.log(err)
      }).finally(() => {
        setLoader(false)
      })




  }

  const SendVenue = (AddressId, mainVenue) => {

    const UpsertVenue = Services.getVenueData(subtenantId, 0, mainVenue, AddressId, true, "", loginUserId)
    UpsertVenue.then((res) => {
      konsole.log("VenuePostRes", res)
      konsole.log("VenuePostResVenueText", res.data.data.venueText)
      konsole.log("VenuePostResVenueId", res.data.data.addressId)
      setApiVenue(res.data.data.venueText)
      setApiAddressId(res.data.data.addressId)
      getAddressByAddressId(res.data.data.addressId);
      RecallgetvenueDataAPI();
      setLoader(false)
    }).catch((err) => {
      konsole.log("VenuePost", err)
    }).finally(() => {
      setLoader(false)
    })

  }



  const onOk = () => {
    form.submit();

  }

  const [ApiVenue, setApiVenue] = useState("")
  const [ApiAddressId, setApiAddressId] = useState("")

  // status(ApiVenue)
  statusId(ApiAddressId)

  const { VenueSave } = useContext(GlobalData);

  useEffect(() => {
    form.setFieldsValue({
      'venueName': VenueSave,
    });
  }, [VenueSave])

  konsole.log("SetFieldVenue", VenueSave)

  return (
    <>
      <style>{`.venue-modal .ant-modal-footer { border-top: 1px solid #bfbfbf; }`}</style>
      <Modal
        visible={visible}
        onCancel={onCancel}
        maskClosable={false}
        enforceFocus={false}
        closable={false}
        bodyStyle={{ padding: '0px' }}
        className="venue-modal"
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop:"15px", marginBottom:"15px" }}>
            <Button onClick={onCancel} style={{ height: '44px',  minWidth:"90px", color: '#720C20', borderColor: '#720C20'}}>Cancel</Button>
            <Button onClick={onOk} style={{ height: '44px', minWidth:"90px", backgroundColor: '#720c20', borderColor: '#720c20', color: '#fff' }}>Add Venue</Button>
          </div>
        }
      >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 16px 12px 16px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color: '#333333', margin: 0 }}>
            Add Venue
          </p>
          <span onClick={onCancel} style={{ cursor: 'pointer', fontSize: '25px', color: '#333333', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>

        <Form style={{padding:"14px"}} form={form} onFinish={EndedData} name="userForm" layout="vertical">
          <Row className='w-100 ms-0' gutter={[8, 8]} >
            <Col xs={24} lg={24} className='ps-0' >
              <Form.Item label="Venue" name="venueName"
                rules={[{
                  required: true,
                  message: 'Enter Venue',
                }]}

              >
                <Input placeholder="Name"
                // onChange={(e) => setGetVenueName(e.target.value)}
                />

              </Form.Item>
            </Col>
            <GlobalVenue.Provider
            //  value={{ sendVenueName: getVenueName }}
            >

              <Address form={form} />
            </GlobalVenue.Provider>
          </Row>
          {/* <Button type='primary' htmlType='submit'>Add Venue</Button> */}
        </Form>
      </Modal>




    </>

  );
}

export default AddEditVenue